import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { TrialOnboardingHelpActionsService } from 'src/app/Services/trial-onboarding-help-actions.service';
import { ActivationJourneyService } from 'src/app/onboarding-checklist/activation-journey.service';

@Component({
  selector: 'app-optional-setup-help-links',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <div class="optional-setup-help-links" *ngIf="show">
      <p class="optional-setup-help-links__hint !mb-2">Need help getting started?</p>
      <div class="optional-setup-help-links__actions">
        <button mat-stroked-button type="button" (click)="help.resumeSetup()"
          *ngIf="!help.isOnboardingCompleted() && !journeyPaused">Resume setup</button>
        <!-- <button mat-stroked-button type="button" (click)="help.startProductTour()">Take tour</button> -->
        <button mat-stroked-button type="button" (click)="help.tryDemoData(!help.isShowingDemoData())">
          {{ help.isShowingDemoData() ? 'Hide' : 'Try' }} sample data
        </button>
      </div>
    </div>
  `,
  styles: [
    `
      .optional-setup-help-links {
        text-align: center;
        margin-top: 12px;
        padding: 0 12px 16px;
      }
      .optional-setup-help-links__hint {
        margin: 0 0 10px;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
      }
      .optional-setup-help-links__actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
      }
    `,
  ],
})
export class OptionalSetupHelpLinksComponent implements OnInit {
  show = false;
  journeyPaused = false;

  constructor(
    public help: TrialOnboardingHelpActionsService,
    private activationJourney: ActivationJourneyService
  ) { }

  ngOnInit(): void {
    const js = this.activationJourney.getState();
    this.journeyPaused = !!(
      this.activationJourney.isEnabled &&
      (js.journeyStatus === 'paused' || (js.continuedLater && !js.finished))
    );
    // During private evaluation, never offer legacy sample-data mixing into live tables.
    if (
      this.activationJourney.isEnabled &&
      js.privateEvaluationActive
    ) {
      this.show = false;
      return;
    }
    this.show = this.help.canShowOptionalHelpLinks();
  }
}
